export const input = () => ({
    '> .ant-form-item > .ant-form-item-label': {
        margin: '0 0 12px',
    },
    '> .ant-form-item > .ant-form-item-control-wrapper > .ant-form-item-control > .ant-form-item-children .ant-select': {
        minWidth: '325px !important',
    },
});
